import { Options, Headers, ReportMessage, ReportReqParams } from "../index.interface"
import { getCommonHeader } from "../util/common"

export const xhrReport = (url: string, data: ReportReqParams, headers?: Headers) => {
  let client: XMLHttpRequest | null = new XMLHttpRequest()
  client.withCredentials = true
  client.open("POST", url, true)
  headers &&
    Object.keys(headers).forEach((key) => {
      client!.setRequestHeader(key, headers[key])
    })
  client.onreadystatechange = function () {
    if (client !== null && client.readyState === 4) client = null
  }
  client.send(JSON.stringify(data))
}

export const fetchReport = (
  url: string,
  data: ReportReqParams,
  commonHeaders: HeadersInit = {}
) => {
  fetch(url, {
    headers: {
      accept: "application/json",
      "content-type": "application/json; charset=UTF-8",
      ...commonHeaders,
    },
    body: JSON.stringify(data),
    method: "POST",
    mode: "cors",
    credentials: "omit",
  })
}

export const report = async (_options: Options, data: ReportMessage) => {
  try {
    const { url, headers, useFetch, appId } = _options
    const params: ReportReqParams = {
      header: await getCommonHeader(_options),
      message: data,
    }

    const headersInfo: any = {
      Accept: "application/json",
      "Content-Type": "application/json; charset=utf-8",
      "X-Kredit-Start-Timestamp": `${Date.now()}`,
      "X-Kredit-Req-APPID": appId,
      "X-Kredit-Req-Source": "1",
    }

    // 如果用户传入了xhr函数，则调用用户传入的函数
    if (_options.xhr) {
      _options.xhr(params)
      return
    }

    // 如果用户不使用fetch上报，则使用xhr上报
    if (!useFetch) {
      xhrReport(url!, params, headers || headersInfo)
      return
    }

    // 如果用户开启 useFetch，则使用fetch上报
    fetchReport(url!, params, headersInfo)
  } catch (e) {
    console.warn("[Insight] [Report] [report] failed:", e)
  }
}
